import {
  core_apimessages_UpdateBillingMethodRequest, core_apimessages_BillingCreditCardEntry,
} from '../schemas/rql';
import { browserInfo } from '../credit_cards/browser_info';
import { ICardData, ITokenizedCreditCardData, IBillingCardAddress } from '../credit_cards/card_data';
import Location from '../lib/wrapped_location';

interface BillingMethodMutationInput {
  cardData: ICardData;
  tokenizedCreditCardData: ITokenizedCreditCardData;
  billingCardAddress: IBillingCardAddress;
  selectedCreditCardId: string;
  editingCard: boolean;
  useExistingCreditCard: boolean;
  returnUrl: string;
}

interface CreditCardInput {
  cardData: ICardData;
  tokenizedCreditCardData: ITokenizedCreditCardData;
  billingCardAddress: IBillingCardAddress;
  selectedCreditCardId: string;
  editingCard: boolean;
  useExistingCreditCard: boolean;
}

export function buildCreditCardEntry(creditCardEntry: CreditCardInput): core_apimessages_BillingCreditCardEntry {
  const {
    useExistingCreditCard,
    editingCard,
    selectedCreditCardId,
    billingCardAddress,
    tokenizedCreditCardData,
    cardData,
  } = creditCardEntry;

  if (useExistingCreditCard) {
    return {
      creditCardId: selectedCreditCardId,
    };
  }

  const creditCardId = editingCard ? selectedCreditCardId : '';

  return {
    creditCardId,
    address: {
      countryCode: billingCardAddress.countryCode,
      postalCode: billingCardAddress.postalCode,
    },
    adyenCreditCard: {
      cardholderName: cardData.cardholderName,
      tokenizedFields: JSON.stringify(tokenizedCreditCardData),
    },
  };
}

export function buildUpdateBillingMethodMutationInput(
  billingMethodMutationInput: BillingMethodMutationInput,
): core_apimessages_UpdateBillingMethodRequest {
  const {
    cardData,
    tokenizedCreditCardData,
    billingCardAddress,
    editingCard,
    selectedCreditCardId,
    useExistingCreditCard,
    returnUrl,
  } = billingMethodMutationInput;

  return {
    returnUrl,
    origin: Location.origin,
    browserInfo: JSON.stringify(browserInfo()),
    creditCard: buildCreditCardEntry({
      cardData,
      tokenizedCreditCardData,
      billingCardAddress,
      editingCard,
      selectedCreditCardId,
      useExistingCreditCard,
    }),
  };
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/billing_method_operation_inputs.ts